import { render } from "./ObjectiveSectionLayout.vue?vue&type=template&id=1baf1431&scoped=true"
import script from "./ObjectiveSectionLayout.vue?vue&type=script&lang=js"
export * from "./ObjectiveSectionLayout.vue?vue&type=script&lang=js"

import "./ObjectiveSectionLayout.vue?vue&type=style&index=0&id=1baf1431&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1baf1431"]])

export default __exports__